import React from "react";
import logo from "../../images/chinook_white.png";
import { useAuthContext } from "../../context/authContext";
import { useNavigate, useLocation } from "react-router-dom";
import { userNavItems } from "./navItems";
import { isNavHrefActive } from "./navLinkActive";
import UserAvatar from "./UserAvatar";

export default function HomeNavbar() {
  const { user, logout } = useAuthContext();

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const loginRedirect = () => {
    navigate("/login");
  };

  const logoutAndRedirect = () => {
    logout();
    navigate("/");
  };

  const goTo = (link) => {
    navigate(link);
  };
  return (
    <header>
      <img src={logo} alt="" className="logo" />
      {
        user?.role ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {userNavItems.map((item) => {
              return (
                <a
                  className={`navElem${
                    isNavHrefActive(pathname, item.link)
                      ? " navElem--active"
                      : ""
                  }`}
                  onClick={() => goTo(item.link)}
                  key={item.label}
                  style={{ textDecoration: "none" }}
                  href={item.link}
                >
                  {item.label}
                </a>
              );
            })}

            {/* <a className="login-button" onClick={logoutAndRedirect}>
              Logout
            </a> */}
            <UserAvatar />
          </div>
        ) : (
          // <a className="navElem login" href="/dev/login">Login</a>
          <div>
            <a className="navElem" onClick={() => goTo("/solutions")}>
              Solutions
            </a>

            <button className="login-button" onClick={loginRedirect}>
              Login
            </button>
          </div>
        )
        // <a className="navElem login" href="/guest/login">Login</a>
      }
    </header>
  );
}
